import PropTypes from "prop-types"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import styles from "../../../styles/Login.module.css"

export default function TotpVerificationScreen({
  verificationTOTPCode,
  onVerificationTOTPCodeChange,
  onResolveTOTP,
  isResending,
  loading,
  onBack,
}) {
  return (
    <>
      <h2>Two-Factor Verification</h2>
      <p className={styles.subhead}>
        Enter the verification code from your authenticator app.
      </p>

      <div className="form-section">
        <div className="form-field">
          <label htmlFor="totpCode">Verification Code</label>
          <InputText
            id="totpCode"
            name="totpCode"
            value={verificationTOTPCode}
            onChange={({ target: { value } }) =>
              onVerificationTOTPCodeChange(value)
            }
            disabled={loading}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault()
                if (loading) return
                onResolveTOTP()
              }
            }}
          />
        </div>
        <Button
          type="button"
          className={`btn ${styles.actionBtn}`}
          label={loading ? "Verifying code..." : "Verify Code"}
          onClick={onResolveTOTP}
          loading={loading}
          disabled={loading || !verificationTOTPCode || isResending}
        />
      </div>

      <button
        className={`${styles["plain-text-link"]} ${styles.backLink}`}
        onClick={onBack}
        type="button"
        disabled={loading}
      >
        Back to Login
      </button>
    </>
  )
}

TotpVerificationScreen.propTypes = {
  verificationTOTPCode: PropTypes.string.isRequired,
  onVerificationTOTPCodeChange: PropTypes.func.isRequired,
  onResolveTOTP: PropTypes.func.isRequired,
  isResending: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onBack: PropTypes.func.isRequired,
}
